<template>
  <div id="controls">
      <h2>Admin Controls</h2>
      <p></p>
      <div id="dash_wrapper" class="spacing">
        <div id="left_menu">
          <ul>
            <li><router-link to="/users" replace><li>Users</li></router-link></li>
            <li><router-link to="/listings" replace><li>Listings</li></router-link></li>
          </ul>
        </div>
        <div id="main_panel">
          <div class="rows spacing">
            <div class="graphical_block"></div>
            <div class="graphical_block"></div>
          </div>
          <div class="rows spacing">
            <div class="graphical_block"></div>
            <div class="graphical_block"></div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import axios from "axios";
  //import ValuationMod from './Valuation';

  export default {
      name: 'Controls',
      data () {
          return {
            
          }
      },
      mounted() {
        // if (val_access) {

        // }
      },
      methods: {

      }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
      font-weight: normal;
  }
  label {
    font-weight: 500;
    text-decoration-line: underline;
  }
  #dash_wrapper ul {
      list-style-type: none;
      padding: 0;
  }

  #dash_wrapper li {
    display: inline-block;
    margin: 0 0 4px 0;
    padding: 4px 10px;
    /* background-color: rgb(205, 220, 57);  */
    /* background-color: rgb(66, 185, 131);  */
    /* background-color: rgb(102, 197, 192); */
    /* background-color: #cddc39; */
    background-color: #CFD8DC;
    text-align: left;
    width: 100%;
  }
  #dash_wrapper li:hover {
    /* background-color: rgb(205, 220, 57); */
    /* background-color: rgb(102, 161, 158); */
    /* background-color: #cddc39; */
    background-color: #CFD8DC;
    width: 100%;
  }
  #dash_wrapper a {
    width: 100%;
    color: #000;
  }
  #dash_wrapper a:hover {
    width: 100%;
    color: rgb(83, 85, 85);
    text-decoration-line: none;
  }
  #controls {
    min-height: 70vh;
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    padding: 20px;
    margin-top: 10px;
  }
  #dash_wrapper {
    margin: 30px 0;
  }
  #main_panel {
    width: 75%;
    /* border: 1px dotted #ccc; */
  }
  #left_menu {
    width: 23%;
    padding: 0;
    /* border: 1px dotted #ccc; */
    text-align: center;
  }
  .spacing {
    display: flex; 
    flex-direction: row; 
    justify-content: space-between;
  }
  .graphical_block {
    min-height: 20vh;
    width: 48%;
    border: 1px solid #666;
    background-color: #CCC;
    /* float: left; */
  }
  .rows {
    width: 100%;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Controls.vue